module.exports = __webpack_public_path__ + "static/media/pool.dee296d1.svg";